'use client';

import { HighlightIcon } from '@/assets/icons';
import type { HomeCapabilityCard } from '@/constants/homeMarketing';
import CapabilityShowcaseSection from './CapabilityShowcaseSection';
import type { CardItem } from '@/components/section/card/DynamicCardSection';

export type HomeCapabilitiesSectionProps = {
  title: string;
  subtitle?: string;
  cards: readonly HomeCapabilityCard[];
  sectionId?: string;
  className?: string;
};

/** Maps localized capability cards into the glass capability grid. */
const HomeCapabilitiesSection: React.FC<HomeCapabilitiesSectionProps> = ({
  title,
  subtitle,
  cards,
  sectionId,
  className,
}) => {
  const cardItems: CardItem[] = cards.map((c) => ({
    title: c.title,
    icon: <HighlightIcon name={c.icon} size={20} />,
    list: [...c.items],
  }));

  return (
    <section id={sectionId} className={className}>
      <CapabilityShowcaseSection title={title} subtitle={subtitle} cards={cardItems} columns={3} />
    </section>
  );
};

export default HomeCapabilitiesSection;
